// İSG uzmanı portalı — Panel (S34-4, api-contract §34, design review
// `S34-carbon-phase2-plan.md` §4 "S34-4 Dashboard"). Eski S33 figür şeridi + "Onay bekleyen
// izinler" mini tablosu + Güvenlik CTA kartı + `AppInfoCard` **TAMAMEN KALDIRILDI** (bu dosyanın
// eski hâli) — `AppInfoCard`in eşdeğeri zaten bağımsız olarak `MobileAppPage.tsx`de yaşıyor
// (aynı `useAppSettings` + `AppDownloadLinks`), ikinci bir kopya İCAT EDİLMEDİ.
//
// **Saha seçici artık HER ŞEYİ süzer (S35 — owner review B3-1, §35.2).** Eskiden `GET
// /dashboard/summary` hiçbir site parametresi ALMIYORDU; seçici YALNIZ "Bugünkü girişler"
// panelini süzüyordu (bu dosyanın S34 sürümü). S35 uca opsiyonel `siteUuid` ekledi (§35.2) —
// seçim artık `GET /dashboard/summary` + `GET /dashboard/action-items`'ın İKİSİNE de gider
// (`activeSite?.uuid`), KPI'lar + "Aksiyon gerekli" listesi + "Bugünkü girişler" ÜÇÜ de AYNI
// sahaya göre daralır. **İstisna (§35.2 normatif, sahip kararı):** taşeron FİRMA belgesi alanları
// (`documentsExpired`/`documentsExpiring`/`contractorsWithExpired/ExpiringDocs` — tek karo,
// `contractorDocsExpiring`) bir sahaya değil FİRMAYA aittir, saha süzgecinden ETKİLENMEZ; bu
// karo saha seçiliyken bağlam satırına "firma geneli" ekler (aşağıdaki karo kurulumuna bkz.) —
// aksi hâlde sahayla ilgisiz bir sayı sahaya aitmiş gibi okunurdu.
//
// **Bağlam satırları — yalnız BACKED olanlar (coordinator kararı, `S34-copy.md`).** Copy
// sheet'in `dashboard.kpi.*.context` anahtarlarından ÜÇÜ (`activePermits`/`pendingApproval`/
// `expiringPermits`) `{{sites}}`/`{{days}}`/`{{date}}` türünden alanlar ister — `ExpertDashboard
// SummaryDto`'da bunları besleyecek bir alan YOK (yalnız `expiringWindow{from,to}`, bir "en
// yakın izin" tarihi DEĞİL). Üçü de DÜŞÜRÜLDÜ; kalan iki karonun (`personnelNotReady`,
// `contractorDocsExpiring`) bağlam satırları — kararları aşağıdaki M1/M6 notlarında.
//
// **`enteredToday` etiketi kasıtlı olarak copy sheet'in YAZILI değerinden SAPAR** (görev
// talimatı) — alan OLAYLARI sayar (bir kişi bugün 2 kez okutursa 2 sayılır), DİSTİNCT kişi
// DEĞİL; "Bugün giriş yapanlar" (copy'nin kelimesi) bunu yanlış ima ederdi. "Bugünkü girişler"
// (aynı ekranın "Bugünkü girişler" panel başlığıyla ZATEN identik metin) kullanılır.
//
// **KPI karosu → liste linki (M10).** Süresi yaklaşan karo artık `/permits`e `status=Active`
// + `status=AwaitingEntryPermit` + `validityEndFrom/To=expiringWindow` ile bağlanır (§34.4
// YENİ çoklu-statü + validityEnd aralığı, `PermitsListPage.tsx`) — karonun sayısıyla listenin
// `filteredTotal`ı ARTIK EŞİT. **Saha seçiliyken (S35) `&siteUuid=` de eklenir** — `/permits`
// bu filtreyi zaten taşıyordu (§14.1, `PermitsListPage.tsx`'in kendi saha seçicisi); sayfa artık
// `?siteUuid=` URL parametresini de İLK render'da okur (validityEndFrom/To'yla AYNI desen), aksi
// hâlde panonun eklediği parametre sessizce YOK SAYILIRDI.
//
// **S34-45 design review M1 — "Belgesi eksik personel" karosu METRİK DEĞİŞTİRDİ.** Eski karo
// `personnelWithMissingDocs`ı (yalnız BELGE eksikliği) başlık yapıp `?kind=entryBlocked` listesine
// bağlanıyordu — ama o liste §34.2 normatif tablosunca `personnelNotReady`ye (belge VEYA eğitim
// eksikliği) eşittir, `personnelWithMissingDocs`e DEĞİL; iki ayrı uyumsuzluk üst üste biniyordu
// (birim: kişi vs. çift; VE alan: yalnız belge vs. belge-veya-eğitim). Owner kararı: karo artık
// `personnelNotReady`yi (KİŞİ sayısı, doğru alan) başlık yapar, bağlam satırı kullanıcının
// TIKLADIĞINDA göreceği tam sayıyı (`actionItemCounts.entryBlocked`, çip sayısıyla AYNI) taşır —
// ikisi FARKLI birim OLABİLİR ama ikisi de tıklama ÖNCESİ görünür, "aynı sayı" YALANI YOK.
// `entryBlocked === 0` iken bağlantı YOK (`permits/get` grant'ı yoksa liste boş rows döner, `div`
// olarak render edilir) — bağlam metni yine de gösterilir (o durumda "0 izin kaydında" da doğrudur,
// listenin kendisi 0 satır döner). Eski `personnelWithMissingDocs` (belge-yalnız sayı) DASHBOARD'DAN
// TAMAMEN KALKAR — owner "istersem bağlam satırına eklenir" dedi, bu slice'ta istenmedi.
//
// **M6 — taşeron belgesi karosu tek BİRİM kullanır.** Başlık zaten `contractorsWithExpiredDocs`
// (TAŞERON sayısı, `documentsExpired` DEĞİL) idi, doğruydu; ama EN/DE etiketi "expiring" diyordu
// (başlık `expired`i sayıyor) VE bağlam satırı `documentsExpired`/`documentsExpiring` (BELGE
// sayısı) karıştırıyordu — 6 sütunda `truncate` en özgün rakamı (`expiring`) elipse
// düşürüyordu. Düzeltme: EN/DE etiketi "expired" der; bağlam TEK birim kullanır
// (`contractorsWithExpiringDocs`, TAŞERON sayısı) — `documentsExpired` artık HİÇ gösterilmez,
// başlık zaten süresi dolmuşu kapsıyor.
//
// "Belgesi eksik personel" karosunun eşleşen bir LİSTE SAYFASI yok — görev talimatınca panonun
// KENDİ "Aksiyon gerekli" listesine (`?kind=entryBlocked#dashboard-actions`) bağlanır.

import {
  Alert,
  Breadcrumb,
  Button,
  type ExpertActionItemKind,
  PageHeader,
  Select,
  Skeleton,
  currentCulture,
  dashboardApi,
  resolveApiErrorMessage,
  useSiteContext,
  visitsApi,
} from '@isgportal/shared';
import { useQuery } from '@tanstack/react-query';
import { BarChart3, Layers } from 'lucide-react';
import { useEffect } from 'react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { PanelHeader } from '../components/PanelHeader';
import { ActionItemsPanel } from '../components/dashboard/ActionItemsPanel';
import { KpiTile } from '../components/dashboard/KpiTile';
import { PermitsByStatusChart } from '../components/dashboard/PermitsByStatusChart';
import { PermitsOpenedChart } from '../components/dashboard/PermitsOpenedChart';
import { TodayEntriesPanel } from '../components/dashboard/TodayEntriesPanel';
import { dashboardKeys } from '../lib/dashboardKeys';
import { useSecurityAccess } from '../lib/securityAccess';
import { useSecurityDayEntries } from '../lib/useSecurityDayEntries';
import { useVisitsAccess } from '../lib/visitsAccess';
import { visitsKeys } from '../lib/visitsKeys';

const KPI_KEYS = [
  'activePermits',
  'pendingApproval',
  'expiringPermits',
  'personnelNotReady',
  'entriesToday',
  'contractorDocsExpiring',
] as const;

function isActionItemKind(value: string | null): value is ExpertActionItemKind {
  return value === 'entryBlocked' || value === 'expiringPermit' || value === 'pendingApproval';
}

export function DashboardPage() {
  const { t } = useTranslation();
  const culture = currentCulture();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  // KPI karosunun `?kind=entryBlocked#dashboard-actions` linki AYNI rotaya (panonun kendisi)
  // gezinir — `ActionItemsPanel`'in filtresini AYARLAR ve paneli GÖRÜNÜME KAYDIRIR (react-router
  // v6 hash'e OTOMATİK kaydırmaz, dosya başlığı bunun İÇİN — bkz. aşağıdaki efekt).
  const initialKind = isActionItemKind(searchParams.get('kind'))
    ? (searchParams.get('kind') as ExpertActionItemKind)
    : undefined;
  useEffect(() => {
    if (location.hash === '#dashboard-actions') {
      document.getElementById('dashboard-actions')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [location.hash]);

  const security = useSecurityAccess();
  const selectedSite = useSiteContext((s) => s.site);
  const setSelectedSite = useSiteContext((s) => s.setSite);
  // Güvenlik düzeltmesi — `SecurityDeskPage.tsx`'in AYNI gerekçesi: `selectedSite`
  // `localStorage`'dan (kanıtlanmamış) gelir; yalnız `security.sites`te (API'den) GERÇEKTEN
  // bulunan girişi kullanır. Panelde bulunamayan bir seçim "seçilmedi" DEĞİL "tüm sahalar"a
  // düşer (dosya başlığı — buradaki `null`ın anlamı).
  const activeSite = selectedSite
    ? security.sites.find((s) => s.uuid === selectedSite.uuid)
    : undefined;
  const siteUuid = activeSite ? activeSite.uuid : null;
  const entries = useSecurityDayEntries(activeSite ? activeSite.uuid : null);

  // S36 #5b (coordinator — ayrı 7. karo tek başına ikinci satırda dağınık dururdu) —
  // `entriesToday` karosunun KENDİ bağlam satırına TAŞINDI (aşağıda `tiles.push`), `enteredToday`
  // sayısına KATILMADAN (dosya başlığı §34.1 "sahada" YASAĞI, triage backend §5): ziyaretçinin
  // çıkışı vardır ("şu an sahada"), personel "bugün onay aldı" demektir. Var olan uç (`GET
  // /visits?status=OnSite`, `OnSiteVisitorsPage.tsx`in AYNI çağrısı) — YENİ uç YOK.
  // `visitsKeys.onSite` zaten `siteUuid`i anahtara katıyor (saha değişince yeniden çeker).
  const visitsAccess = useVisitsAccess();
  const onSiteVisitorsParams = {
    status: 'OnSite' as const,
    siteUuid: siteUuid ?? undefined,
    page: 1,
    pageSize: 1,
  };
  const onSiteVisitorsQuery = useQuery({
    queryKey: visitsKeys.onSite(onSiteVisitorsParams),
    queryFn: () => visitsApi.listVisits(onSiteVisitorsParams),
    enabled: visitsAccess.status === 'granted',
    staleTime: 60_000,
  });

  const summaryQuery = useQuery({
    queryKey: dashboardKeys.summary(siteUuid),
    queryFn: () => dashboardApi.getDashboardSummary({ siteUuid: siteUuid ?? undefined }),
    staleTime: 60_000,
  });
  const summary = summaryQuery.data;

  function handleSiteChange(uuid: string) {
    if (!uuid) {
      setSelectedSite(null);
      return;
    }
    const site = security.sites.find((s) => s.uuid === uuid);
    if (site) {
      setSelectedSite({ uuid: site.uuid, name: site.name });
    }
  }

  const numberFormat = new Intl.NumberFormat(culture);
  const formattedDate = new Intl.DateTimeFormat(culture, { dateStyle: 'full' }).format(new Date());

  const tiles: {
    key: (typeof KPI_KEYS)[number];
    label: string;
    formattedValue: string;
    // S36 #5b — `entriesToday`nin bağlamı bazen bir `<Link>` taşır (aşağıya bkz.); `ReactNode`
    // diğer beş karonun düz metin kullanımını KIRMAZ (`string` de bir `ReactNode`).
    context?: ReactNode;
    href?: string;
  }[] = [];
  if (summary) {
    // S35 (owner review B3-1) — saha seçiliyken `/permits` drill-through'lara `&siteUuid=`
    // eklenir (§35.2, `PermitsListPage.tsx`'in kendi `?siteUuid=` ilk-render okuması ile
    // eşleşir); `activePermits`/`pendingApproval`/`expiringPermits` ÜÇÜ de bu izini taşır —
    // taşeron belgesi karosu (aşağıda) İSTİSNADIR, firma geneli kalır (§35.2 normatif).
    const activePermitsParams = new URLSearchParams({ status: 'Active' });
    const pendingApprovalParams = new URLSearchParams({ status: 'Submitted' });
    const expiringParams = new URLSearchParams();
    expiringParams.append('status', 'Active');
    expiringParams.append('status', 'AwaitingEntryPermit');
    expiringParams.set('validityEndFrom', summary.expiringWindow.from);
    expiringParams.set('validityEndTo', summary.expiringWindow.to);
    if (siteUuid) {
      activePermitsParams.set('siteUuid', siteUuid);
      pendingApprovalParams.set('siteUuid', siteUuid);
      expiringParams.set('siteUuid', siteUuid);
    }
    tiles.push({
      key: 'activePermits',
      label: t('dashboard.kpi.activePermits'),
      formattedValue: numberFormat.format(summary.activePermits),
      href: `/permits?${activePermitsParams.toString()}`,
    });
    tiles.push({
      key: 'pendingApproval',
      label: t('dashboard.kpi.pendingApproval'),
      formattedValue: numberFormat.format(summary.awaitingApproval),
      href: `/permits?${pendingApprovalParams.toString()}`,
    });
    tiles.push({
      key: 'expiringPermits',
      label: t('dashboard.kpi.expiringPermits'),
      formattedValue: numberFormat.format(summary.expiringIn7Days),
      href: `/permits?${expiringParams.toString()}`,
    });
    tiles.push({
      key: 'personnelNotReady',
      label: t('dashboard.kpi.personnelNotReady'),
      formattedValue: numberFormat.format(summary.personnelNotReady),
      context: t('dashboard.kpi.personnelNotReady.context', {
        count: summary.actionItemCounts.entryBlocked,
      }),
      // M1 — yalnız listenin GERÇEKTEN satır ÜRETTİĞİ (`entryBlocked > 0`) durumda bağlantı;
      // `permits/get` grant'ı yoksa sayaç 0'dır (NULL DEĞİL, §34.2), liste boş döner.
      href:
        summary.actionItemCounts.entryBlocked > 0
          ? '/?kind=entryBlocked#dashboard-actions'
          : undefined,
    });
    // Alan kapısı (§34.1) — `null` GİZLENİR, `0` BASILMAZ (dosya başlığı, `dashboard.ts`).
    if (summary.enteredToday != null) {
      // S36 #5b — grant kapısı (`visits/list` yoksa 403): bağlam satırı hiç EKLENMEZ, karo
      // ÖNCEKİYLE (bu satırdan önceki hâliyle) AYNI kalır — bağlamsız, `/security` linkli.
      // Grant VARSA bağlam bir `<Link to="/visitors">` taşır; dış karo o durumda `href` ALMAZ
      // (iç içe `<a>` olurdu — koordinatör "don't nest links"). `/security`e erişim bu durumda
      // yan menüden bir tık ötede kalır, ikinci bir tıklanabilir alan İCAT edilmez.
      const onSiteContext =
        visitsAccess.status === 'granted' && onSiteVisitorsQuery.data ? (
          <Link to="/visitors" className="text-primary hover:underline">
            {t('dashboard.kpi.entriesToday.context', {
              count: onSiteVisitorsQuery.data.filteredTotal,
            })}
          </Link>
        ) : undefined;
      tiles.push({
        key: 'entriesToday',
        label: t('dashboard.kpi.entriesToday'),
        formattedValue: numberFormat.format(summary.enteredToday),
        context: onSiteContext,
        href: onSiteContext ? undefined : '/security',
      });
    }
    if (summary.contractorsWithExpiredDocs != null) {
      // M6 — TEK birim (TAŞERON sayısı, `contractorsWithExpiringDocs`); `documentsExpired`
      // (BELGE sayısı) artık burada YOK — başlık zaten "expired"i kapsıyor, bağlam yalnız
      // "yakında dolacak" tarafını ekler. 30 gün §28.3'ün KANONİK eşiği (api-contract.md
      // ~1686) — dinamik bir alan DEĞİL, sabit bir iş kuralı sabiti (`expiringIn7Days`in
      // adına GÖMÜLÜ "7"yle AYNI kategori).
      //
      // S35 (owner review B3-1) — bu karo firma geneli KALIR (§35.2 normatif, taşeron firma
      // belgesi bir sahaya değil firmaya aittir); saha seçiliyken bağlam satırı BUNU açıkça
      // söyler (`dashboard.kpi.scopeCompanyWide`, üç dilde), aksi hâlde diğer beş karo sahaya
      // daralmışken bu tek karo sahayla ilgisiz bir sayı gösterip sahaya aitmiş gibi okunurdu.
      // Sıra kasıtlı: not METNİN BAŞINDA (M7'nin `truncate` kısaltması sondan keser — uyarı hiç
      // görünmeme riskini taşımamalı).
      const expiringDocsContext = t('dashboard.kpi.contractorDocsExpiring.context', {
        count: summary.contractorsWithExpiringDocs ?? 0,
      });
      tiles.push({
        key: 'contractorDocsExpiring',
        label: t('dashboard.kpi.contractorDocsExpiring'),
        formattedValue: numberFormat.format(summary.contractorsWithExpiredDocs),
        context: siteUuid
          ? `${t('dashboard.kpi.scopeCompanyWide')} · ${expiringDocsContext}`
          : expiringDocsContext,
        href: '/contractors?status=Active&compliance=expired',
      });
    }
  }

  return (
    // İçerik genişliği 1584px'de kapanır ve SOLA hizalı kalır (`mx-auto` YOK — sayfa sol kenarını
    // `<main>`in diğer her sayfasıyla PAYLAŞMAYA devam eder; design review §4 "Grid", S34-4 QA
    // düzeltmesi). 1920/2560'ta 30 sütun ve 8 satırlık listeler yalnız UZAR, okunaklılık ARTMAZ.
    <div className="flex max-w-[1584px] flex-col gap-6">
      <Breadcrumb items={[{ label: t('dashboard.title') }]} />
      <PageHeader
        title={t('dashboard.title')}
        helperText={formattedDate}
        actions={
          security.status === 'granted' && security.sites.length > 0 ? (
            <div className="w-56">
              <Select
                aria-label={t('dashboard.site.label')}
                value={activeSite?.uuid ?? ''}
                options={[
                  { value: '', label: t('dashboard.site.all') },
                  ...security.sites.map((s) => ({ value: s.uuid, label: s.name })),
                ]}
                onChange={(e) => handleSiteChange(e.target.value)}
              />
            </div>
          ) : null
        }
      />

      {/* Owner review B2 item 3 (2026-09-28) — 6 karo 1366×768'de (256px genişletilmiş kenar
          çubuğu, `@container` genişliği ~1046px) eski `@[87.5rem]` (1400px) eşiğinin ALTINDA
          kalıp 3 sütuna/2 SATIRA düşüyordu; KpiTile'ın eski boyutuyla (128px×2 satır) bu blok
          tek başına ekranın İLK GÖRÜNÜMÜNÜN çoğunu kaplıyor, "Aksiyon gerekli" listesi
          kaydırmadan hiç görünmüyordu. Eşik `@[60rem]` (960px) — 1366'da (1046px) HEM 1280'de
          (main TAM 960px) artık TEK satır 6 sütun; `KpiTile.tsx`'in kompakt boyutuyla (dosya
          başlığı notu) BİRLİKTE "Aksiyon gerekli" katlanmadan ÖNCE başlar. 960px altında (ör.
          1024, nav genişletilmiş) 3 sütun/2 satır DAVRANIŞI KORUNUR — owner yalnız 1366'yı
          hedefledi, daha dar ekranlarda 6 dar sütun okunaksız olurdu. */}
      <div className="@container">
        {summaryQuery.isPending ? (
          <div className="grid grid-cols-2 gap-3 @[40rem]:grid-cols-3 @[60rem]:grid-cols-6">
            {KPI_KEYS.map((key) => (
              <KpiTile key={key} label={t(`dashboard.kpi.${key}`)} formattedValue="" isLoading />
            ))}
          </div>
        ) : summaryQuery.isError ? (
          <Alert tone="danger">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <span>{resolveApiErrorMessage(summaryQuery.error, t)}</span>
              <Button variant="ghost" size="sm" onClick={() => summaryQuery.refetch()}>
                {t('dashboard.retry')}
              </Button>
            </div>
          </Alert>
        ) : (
          <div className="grid grid-cols-2 gap-3 @[40rem]:grid-cols-3 @[60rem]:grid-cols-6">
            {tiles.map((tile) => (
              <KpiTile
                key={tile.key}
                label={tile.label}
                formattedValue={tile.formattedValue}
                context={tile.context}
                href={tile.href}
              />
            ))}
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 gap-6 xl:grid-cols-3">
        <div className="flex flex-col gap-6 xl:col-span-2">
          <ActionItemsPanel
            counts={summary?.actionItemCounts ?? null}
            initialKind={initialKind}
            siteUuid={siteUuid}
          />
          {/* S2 — panel kabuğu "Tüm sahalar"da da render edilir (`TodayEntriesPanel`'in dosya
              başlığı); yalnız `siteName` `null` olur, gövde saha-seç uyarısına döner. */}
          {security.status === 'granted' ? (
            <TodayEntriesPanel entries={entries} siteName={activeSite ? activeSite.name : null} />
          ) : null}
        </div>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-1">
          <div className="flex flex-col rounded-sm border border-border bg-surface shadow-sm">
            <PanelHeader icon={Layers} title={t('dashboard.chart.permitsByStatus.title')} />
            {/* M5 — yüklenirken "yok" DEMEZ (eski hâli her soğuk yüklemede `.empty` metnini
                gösteriyordu); S3 — hatada tam hata metni TEKRAR EDİLMEZ (üstteki KPI `Alert`i
                zaten gösteriyor), yalnız kısa "—" + "Yüklenemedi" (plan §4 "tile error rule"). */}
            {summaryQuery.isPending ? (
              <div className="p-4">
                <Skeleton className="h-4 w-full" />
              </div>
            ) : summaryQuery.isError ? (
              <div className="flex flex-col gap-1 p-4">
                <p className="text-2xl font-semibold text-fg">—</p>
                <p className="text-sm text-muted">{t('dashboard.chart.unavailable')}</p>
              </div>
            ) : summary ? (
              <PermitsByStatusChart permitsByStatus={summary.permitsByStatus} />
            ) : null}
          </div>
          <div className="flex flex-col rounded-sm border border-border bg-surface shadow-sm">
            <PanelHeader icon={BarChart3} title={t('dashboard.chart.permitsOpened.title')} />
            {summaryQuery.isPending ? (
              <div className="p-4">
                <Skeleton className="h-40 w-full" />
              </div>
            ) : summaryQuery.isError ? (
              <div className="flex flex-col gap-1 p-4">
                <p className="text-2xl font-semibold text-fg">—</p>
                <p className="text-sm text-muted">{t('dashboard.chart.unavailable')}</p>
              </div>
            ) : summary ? (
              <PermitsOpenedChart days={summary.permitsCreatedPerDay} culture={culture} />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
